export function createOrgSlug(organizationId: string, name: string): string {
  const slugified = name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return `${organizationId}-${slugified}`;
}

export function parseOrgId(slug: string): string {
  return slug.slice(0, 36);
}
